<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="name"
            :name="$t('fields.name').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.name"
            :counter="30"
            :label="$t('fields.name')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { editorsGroupService } from '../../../utils/services/editorsGroup.service';

  export default {
    name: 'EditorModal',
    data() {
      return {
        stored: null,
        editorGroup: {},
        form: {
          name: null,
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
      fetchEditorGroup(id) {
        return editorsGroupService.get(id)
        .then(response => {
            this.editor = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);
      if (this.data.stored.id) {
        await this.fetchEditorGroup(this.data.stored.id);
        this.form = {
          id: this.data.stored.id,
          name: this.editor.name,
        };
      }
      this.loadingModal(false);
    },
  };
</script>
